import axios from "axios";
import moment from "moment";

export default async function syncRecordsSavedOffline(db, settings) {
  let err = { readings: [], sms: [], photos: [] };

  await db
    .get("dm_recsToSync")
    .then(async (doc) => {
      if (!doc || !doc.records || doc.records.length == 0) return;

      //console.log("records to be saved length", doc.records);
      for (let i = 0; i < doc.records.length; i++) {
        let parameter = {
          Account: doc.records[i].account,
          CaseId: doc.records[i].caseId,
          ConnectionId: doc.records[i].connectionId,
          Comment: doc.records[i].comment,
        };

        let gpsParameter = {
          CoordLat: doc.records[i].geoLocationObj.lat,
          CoordLong: doc.records[i].geoLocationObj.lng,
          CoordAccuracy: doc.records[i].geoLocationObj.accuracy,
          ...parameter,
        };

        parameter = {
          FinalReading: doc.records[i].finalReading,
          FinalReadingDate: doc.records[i].finalReadingDate,
          FinalReadingClockOver: doc.records[i].finalReadingClockOver,
          SkipMeterReading:
            (doc.records[i].finalReading == null ||
              doc.records[i].finalReading == 0 ||
              doc.records[i].finalReading == "0") &&
            doc.records[i].isAllowDisconReconWithoutReading == true
              ? true
              : false,
          RemoveMeter: doc.records[i].isRemoveInstallMeter,
          InstallMeterId:
            doc.records[i].isRemoveInstallMeter == false
              ? 0
              : doc.records[i].meterId,
          ...parameter,
        };

        if (
          doc.records[i].isRemoveInstallMeter &&
          doc.records[i].stage == 5 &&
          doc.records[i].meterIdForSave
        )
          parameter["InstallMeterId"] = doc.records[i].meterIdForSave;
        else parameter["InstallMeterId"] = 0;

        //console.log("dm_recsToSync", doc.records[i])
        //console.log("parameter", parameter)

        let requestFunction;
        let gpsRequestFunction =
          doc.records[i].stage == 2
            ? "SetDisconnectionLocation"
            : "SetReconnectionLocation";

        if (
          doc.records[i].status != 3 &&
          !doc.records[i].isUnderInvestigation &&
          !doc.records[i].onlyComments
        ) {
          parameter = {
            FinalReading: doc.records[i].finalReading,
            FinalReadingDate: doc.records[i].finalReadingDate,
            FinalReadingClockOver: doc.records[i].finalReadingClockOver,
            SkipMeterReading:
              (doc.records[i].finalReading == null ||
                doc.records[i].finalReading == 0 ||
                doc.records[i].finalReading == "0") &&
              settings.isAllowDisconReconWithoutReading == true
                ? true
                : false,
            RemoveMeter: doc.records[i].removeMeter,
            InstallMeterId:
              doc.records[i].removeMeter === false ? 0 : doc.records[i].meterId,
            ...parameter,
          };

          requestFunction =
            doc.records[i].stage == 5
              ? "SetReconnectionFinalReading"
              : "SetDisconnectionFinalReading";
        } else if (doc.records[i].onlyComments === true) {
          requestFunction =
            doc.records[i].stage == 2
              ? "SetDisconnectionComment"
              : "SetReconnectionComment";
        } else {
          requestFunction =
            doc.records[i].removeFromInvestigation === true
              ? "RemoveFromInvestigation"
              : "PutUnderInvestigation";
        }

        await axios
          .post("/DmConnection/" + gpsRequestFunction, gpsParameter)
          .then((response) => {
            if (response.data.data.status != 0) {
              doc.records[i]["error"] = response.data.data.text;
              doc.records[i].isSynced = false;
              err.readings.push({ reading: doc.records[i] });
            }
          })
          .catch((e) => {
            doc.records[i].isSynced = false;
            err.readings.push({ reading: doc.records[i] });
          });

        await axios
          .post("/DmConnection/" + requestFunction, parameter)
          .then((response) => {
            if (response.data.data.status == 0) {
              doc.records[i].isSynced = true;
            } else {
              doc.records[i]["error"] = response.data.data.text;
              doc.records[i].isSynced = false;
              err.readings.push({ reading: doc.records[i] });
            }
          })
          .catch((e) => {
            doc.records[i].isSynced = false;
            err.readings.push({ reading: doc.records[i] });
          });
      }

      if (doc.records.filter((a) => a.isSynced == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {
            //console.log(err);
          });
      }
    })
    .catch((err) => {});

  await db
    .get("dm_picsToSync")
    .then(async (doc) => {
      if (!doc || !doc.pictures || doc.pictures.length == 0) return;

      //console.log("records to be saved length", doc.records.length);
      for (let i = 0; i < doc.pictures.length; i++) {
        let parameters = {
          account: doc.pictures[i].account,
          caseId: doc.pictures[i].caseId,
          photoBase64: doc.pictures[i].img,
        };

        await axios
          .post("/DmConnection/AddPhoto", parameters)
          .then((response) => {
            if (response.data.data.status == 0) {
              doc.pictures[i].isSynced = true;
            } else {
              doc.pictures[i]["error"] = response.data.data.text;
              doc.pictures[i].isSynced = false;
              let temp = { ...doc.pictures[i] };
              delete temp.img;
              err.photos.push(temp);
            }
          })
          .catch((e) => {
            doc.pictures[i].isSynced = false;
            let temp = { ...doc.pictures[i] };
            delete temp.img;
            err.photos.push(temp);
          });
      }

      if (doc.pictures.filter((a) => a.isSynced == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {
            //console.log(err);
          });
      }
    })
    .catch((err) => {});

  await db
    .get("dm_smsToSync")
    .then(async (doc) => {
      if (!doc || !doc.sms || doc.sms.length == 0) return;

      //console.log("records to be saved length", doc.records.length);
      for (let i = 0; i < doc.sms.length; i++) {
        let parameter = {
          CaseId: doc.sms[i].caseId,
          Custkey: doc.sms[i].account,
        };

        await axios
          .post("/DmCase/SendSms", parameter)
          .then((response) => {
            if (response.status == 200) {
              doc.sms[i].isSynced = true;
            } else {
              doc.sms[i]["error"] = response.data;
              doc.sms[i].isSynced = false;
              err.sms.push(doc.sms[i]);
            }
          })
          .catch((e) => {
            err.sms.push(doc.sms[i]);
            doc.sms[i].isSynced = false;
          });
      }

      if (doc.sms.filter((a) => a.isSynced == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {
            //console.log(err);
          });
      }
    })
    .catch((err) => {});

  await db
    .get("dm_adHoc_smsToSync")
    .then(async (doc) => {
      if (!doc || !doc.adHocSms || doc.adHocSms.length == 0) return;

      //console.log("records to be saved length", doc.adHocSms.length);
      for (let i = 0; i < doc.adHocSms.length; i++) {
        let parameter = {
          Message: doc.adHocSms[i].message,
          Account: doc.adHocSms[i].account,
        };

        await axios
          .post("/DmConnection/SendAdHocSms", parameter)
          .then((response) => {
            if (response.data.data.status == 0) {
              doc.adHocSms[i].isSynced = true;
            } else {
              doc.adHocSms[i]["error"] = response.data.data.text;
              doc.adHocSms[i].isSynced = false;
              err.sms.push(doc.adHocSms[i]);
            }
          })
          .catch((e) => {
            err.sms.push(doc.adHocSms[i]);
            doc.adHocSms[i].isSynced = false;
          });
      }

      if (doc.adHocSms.filter((a) => a.isSynced == false).length == 0) {
        db.remove(doc)
          .then((resultRemove) => {})
          .catch((err) => {
            //console.log(err);
          });
      }
    })
    .catch((err) => {});

  return err;
}
